"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

require("../../assets/css/components/card/CardAccordion.css");

var _Progress = require("../progress/Progress");

var _Progress2 = _interopRequireDefault(_Progress);

var _Icone = require("../elements/Icone");

var _Icone2 = _interopRequireDefault(_Icone);

var _Form = require("../form/Form");

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardAccordion = function (_React$Component) {
    _inherits(CardAccordion, _React$Component);

    function CardAccordion(props) {
        _classCallCheck(this, CardAccordion);

        var _this = _possibleConstructorReturn(this, (CardAccordion.__proto__ || Object.getPrototypeOf(CardAccordion)).call(this, props));

        _this.toogle = function (event) {
            event.preventDefault();
            if (!_this.props.notClose) {
                if (!_this.state.expanded && _this.state.content === null && _this.props.lazyLoad && _this.props.onLoad) _this.props.onLoad();
                if (_this.state.expanded && _this.props.lazyLoad && _this.props.onLoad) _this.setState(function (prevState, prevProps) {
                    return {
                        expanded: !prevState.expanded,
                        content: null
                    };
                });else _this.setState(function (prevState, prevProps) {
                    return {
                        expanded: !prevState.expanded
                    };
                });
            }
        };

        _this.setContent = function (content) {
            _this.setState({ content: content });
        };

        _this.getContent = function () {
            if (_this.state.content && _this.state.expanded) {
                if (_this.props.form) return _react2.default.createElement(
                    _Form2.default,
                    { onSubmit: _this.props.onSubmit },
                    _react2.default.createElement(
                        "div",
                        { className: "mdl-card__supporting-text " + (_this.props.noPadding ? "no-padding" : "") },
                        _this.props.children
                    ),
                    _this.hasAction()
                );else return _react2.default.createElement(
                    "div",
                    null,
                    _react2.default.createElement(
                        "div",
                        { className: "mdl-card__supporting-text " + (_this.props.noPadding ? "no-padding" : "") },
                        _this.props.children
                    ),
                    _this.hasAction()
                );
            }
        };

        _this.getProgressBarByLazyLoading = function () {
            if (!_this.state.content && _this.props.lazyLoad) return _this.getProgressBar();
        };

        _this.getProgressBarByAction = function () {
            if (_this.props.displayLoading) return _this.getProgressBar();
        };

        _this.getProgressBar = function () {
            return _react2.default.createElement(_Progress2.default, { position: _this.props.loadingPosition || "bottom" });
        };

        _this.getIcon = function () {
            if (!_this.props.onClose) return _react2.default.createElement(_Icone2.default, { icone: "keyboard_arrow_down" });
        };

        _this.state = {
            content: _this.props.children,
            expanded: _this.props.open || _this.props.notClose
        };
        _this.toogle = _this.toogle.bind(_this);
        _this.setContent = _this.setContent.bind(_this);
        return _this;
    }

    _createClass(CardAccordion, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.children != null) setTimeout(function () {
                _this2.setContent(nextProps.children);
            }, 2000);
        }
    }, {
        key: "hasAction",
        value: function hasAction() {
            if (this.props.actions) return _react2.default.createElement(
                "div",
                { className: "mdl-card__actions mdl-card--border" },
                this.props.actions
            );
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                { className: "card-accordion-box" + (this.state.expanded ? " card-accordion-opened" : "") },
                _react2.default.createElement(
                    "a",
                    { id: this.props.id, href: '#', onClick: this.toogle, "aria-expanded": this.state.expanded,
                        "aria-haspopup": !this.props.notClose,
                        className: "card-accordion-title" + (this.state.expanded ? " card-accordion-opened" : "") },
                    this.props.titulo,
                    this.getIcon()
                ),
                _react2.default.createElement(
                    "div",
                    { className: "card-accordion-body" + (this.state.expanded ? " card-accordion-opened" : "") },
                    this.getProgressBarByLazyLoading(),
                    this.getProgressBarByAction(),
                    this.getContent()
                )
            );
        }
    }]);

    return CardAccordion;
}(_react2.default.Component);

exports.default = CardAccordion;

CardAccordion.propTypes = {
    titulo: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/card/CardAccordion.js
// module id = 1105
// module chunks = 0